export default __webpack_public_path__ + "static/media/svg-5.1c7d9798.svg";